// The week's awards on the scoreboard (B-385): each award, who holds it and
// by what, as it stands while the week is played and as it was won once it is
// final. A list in the week's column, where it was a strip across the top
// that a phone showed two of.

import type { AwardCardView } from '@fsp/domain';
import { Link } from 'react-router-dom';
import { useLeagueBase } from '../../data/hooks';
import { TeamMark } from '../../kit';
import { Panel } from '../../kit/Panel';
import { Term } from '../../kit/Why';
import { AwardIcon } from '../shared/AwardKit';

export function AwardsRace({
  awards,
  period,
  final,
}: {
  awards: AwardCardView[];
  period: number;
  /** The week is settled: these are its awards, not the race for them. */
  final: boolean;
}) {
  const base = useLeagueBase();
  const held = awards.filter((a) => a.winners.length > 0);
  if (held.length === 0) return null;
  return (
    <Panel
      title={final ? 'Awards' : 'As it stands'}
      meta={
        <Link to={`${base}/awards?period=${period}`} className="fsp-linklike fsp-sb-more">
          All awards
        </Link>
      }
    >
      <ul className="fsp-ar">
        {held.map((a) => {
          const w = a.winners[0]!;
          return (
            // The award over its team, so a long award name and a long team
            // name each have the row's width: side by side, one of them was
            // cut in a column a desktop gives 340 px.
            <li key={a.id} className="fsp-ar-row" data-tone={a.tone}>
              <span className="fsp-ar-icon">
                <AwardIcon icon={a.icon} size={14} />
              </span>
              <span className="fsp-ar-name">
                {/* What it is for, when asked (B-374). */}
                <Term tip={a.line || a.blurb} name={a.name}>
                  {a.name}
                </Term>
              </span>
              <span className="fsp-ar-value fsp-num">{w.valueLabel}</span>
              <span className="fsp-ar-team">
                <TeamMark team={w.team} size={16} />
                <span className="fsp-ar-team-name">
                  {w.team.name}
                  {a.winners.length > 1 ? ` +${a.winners.length - 1}` : ''}
                </span>
              </span>
            </li>
          );
        })}
      </ul>
    </Panel>
  );
}
